/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Replace_Ellipses_DescInputs */



/**
* | output |
* | --- |
* | "Replace multiple dots with ellipses" |
*
* @param {Replace_Ellipses_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const replace_ellipses_desc = /** @type {((inputs?: Replace_Ellipses_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Replace_Ellipses_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Remplacer les points multiples par des points de suspension")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mehrere Punkte durch Auslassungspunkte ersetzen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sostituisci più punti con ellissi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Замените несколько точек многоточием.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reemplazar varios puntos con elipses")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将多个点替换为省略号")
	if (locale === "ja") return /** @type {LocalizedString} */ ("複数のドットを省略記号に置き換える")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एकाधिक बिंदुओं को दीर्घवृत्तों से बदलें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Substitua vários pontos por reticências")
	return /** @type {LocalizedString} */ ("Replace multiple dots with ellipses")
});